import { render, staticRenderFns } from "./fbpClaimHistory.vue?vue&type=template&id=8727b0e6&scoped=true"
import script from "./fbpClaimHistory.vue?vue&type=script&lang=js"
export * from "./fbpClaimHistory.vue?vue&type=script&lang=js"
import style0 from "./fbpClaimHistory.vue?vue&type=style&index=0&id=8727b0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8727b0e6",
  null
  
)

export default component.exports